import { getFirestore, doc, collection, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'teams/'

function docToInstance(doc) {
  const data = doc.data()
  return data ? new Team(doc.id, data.name, data.publicName, data.logo, data.users, data.roles) : null
}

export default class Team {
  constructor(id, name, publicName, logo, users, roles) {
    this.id = id
    this.name = name
    this.publicName = publicName
    this.logo = logo
    this.users = users
    this.roles = roles
  }

  static initOne(name){
    let team = new Team(null, name, name, null, [], {})
    return team
  }

  async save() {
    const data = {
      name: this.name,
      publicName: this.publicName,
      logo: this.logo,
      users: this.users,
      roles : this.roles,
    }

    if (this.id) {
      await catalogueCommands.team.update(this.id, data)
    } else {
      const result = await catalogueCommands.team.create(data)
      this.id = result.id
    }
    return this
  }

  static async listenAll(callback) {
    // La fonction de désabonnement est renvoyée : sans elle, l'écran des équipes
    // laissait son écouteur actif après sa fermeture.
    return onSnapshot(collection(db, await getCollectionPath(collectionName)), snapshot => {
      const list = []
      snapshot.forEach(doc => {
        list.push(docToInstance(doc))
      })
      callback(list)
    })
  }

  static async listenById(id, callback) {
    return onSnapshot(doc(db, await getCollectionPath(collectionName), id), snapshot => {
      callback(docToInstance(snapshot))
    })
  }

  static async getAll(){
    let response = await getDocs(collection(db, await getCollectionPath(collectionName)))
    let list = []
    response.forEach(doc => {
        list.push(docToInstance(doc))
    })
    return list
}


  async delete() {
    await catalogueCommands.team.delete(this.id)
  }


}
